import script from "./ProviderOffersView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderOffersView.vue?vue&type=script&setup=true&lang=js"

import "../assets/provider-view.css?vue&type=style&index=0&id=c0f09eaa&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0f09eaa"]])

export default __exports__